module.exports = __webpack_public_path__ + "static/media/green3.97edabc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/baby/green3.svg
// module id = 1334
// module chunks = 31